module.exports = __webpack_public_path__ + "img/NewHavenCity-800-450.9275d51e.jpg";